
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { SubmitSectionProps } from './types';
import { useFirebase } from '@/context/FirebaseProvider'; // Changed from useDataUtils

const SubmitSection: React.FC<SubmitSectionProps> = ({
  handleSubmit,
  businessDetails,
  portfolioName = 'Portfolio'
}) => {
  const navigate = useNavigate();
  const { firebaseUser } = useFirebase(); // Use firebaseUser for auth check

  // Redirect to login if needed
  const handleButtonClick = () => {
    // Check if user is logged in
    if (!firebaseUser) {
      navigate('/login');
    } else {
      handleSubmit();
    }
  };

  return (
    <div className="flex justify-end pt-4">
      <Button 
        onClick={handleButtonClick} 
        className="w-full"
      >
        Continue
      </Button>
    </div>
  );
};

export default SubmitSection;
